class PasswordGate {
  constructor() {
    this.gate = document.querySelector("[data-collection-password-gate]");
    this.overlay = document.querySelector("[data-password-overlay]");

    if (!this.gate || !this.overlay) return;

    this.body = document.body;
    this.input = this.gate.querySelector(".collection-password-modal__input");
    this.button = this.gate.querySelector(".collection-password-modal__button");
    this.error = this.gate.querySelector("[data-error]");

    this.passwordHash = this.gate.getAttribute("data-password-hash");
    this.collectionId = this.gate.getAttribute("data-collection-id");
    this.cookieName = `collection_access_${this.collectionId}`;

    if (this.#hasAccessCookie()) {
      this.gate.classList.add("hidden");
      this.overlay.classList.add("hidden");
      return;
    }

    this.#init();
  }

  #hasAccessCookie() {
    return document.cookie.split("; ").includes(`${this.cookieName}=1`);
  }

  #setAccessCookie(days = 7) {
    const date = new Date();
    date.setTime(date.getTime() + days * 86400000);
    document.cookie = `${this.cookieName}=1; expires=${date.toUTCString()}; path=/`;
  }

  async #sha256(str) {
    const data = new TextEncoder().encode(str);
    const hashBuffer = await crypto.subtle.digest("SHA-256", data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map(b => b.toString(16).padStart(2, "0")).join("");
  }

  #fadeOut() {
    this.overlay.classList.add("is-fading-out");
    this.gate.classList.add("is-fading-out");

    setTimeout(() => {
      this.overlay.remove();
      this.gate.remove();
      this.body.classList.remove("collection-password-locked");
    }, 1300);
  }

  async #unlock() {
    if (!this.input) return;

    const typedHash = await this.#sha256(this.input.value);

    if (typedHash === this.passwordHash) {
      this.error.style.display = "none";
      this.#setAccessCookie();
      this.#fadeOut();
    } else {
      this.error.style.display = "block";
    }
  }

  #bindEvents() {
    this.button?.addEventListener("click", () => this.#unlock());
    this.input?.addEventListener("keyup", e => {
      if (e.key === "Enter") this.#unlock();
    });
  }

  #init() {
    this.body.classList.add("collection-password-locked");
    this.#bindEvents();
  }
}

document.addEventListener("DOMContentLoaded", () => new PasswordGate());